<template>
  <text
    v-if="isVisible"
    :x="x"
    :y="y"
    class="marker-label"
  >
    <!-- name only -->
    <template v-if="!showCount">
      <tspan
        :font-size="18 * sizeScale"
        :stroke-width="3 * sizeScale"
        stroke="white"
        fill="#333"
        paint-order="stroke fill"
        dominant-baseline="middle"
        font-weight="bold"
      >
        {{ truncatedLabel }}
      </tspan>
    </template>
    <!-- name + count -->
    <template v-else>
      <tspan
        :x="x"
        :dy="-6 * sizeScale"
        :font-size="18 * sizeScale"
        :stroke-width="3 * sizeScale"
        stroke="white"
        fill="#333"
        paint-order="stroke fill"
        font-weight="bold"
      >
        {{ truncatedLabel }}
      </tspan>
      <tspan
        :x="x"
        :dy="14 * sizeScale"
        :font-size="14 * sizeScale"
        :stroke-width="4 * sizeScale"
        stroke="white"
        font-weight="500"
        fill="#444"
        paint-order="stroke fill"
      >
        ({{ countDisplay }})
      </tspan>
    </template>
  </text>
</template>

<script>
const MAX_LABEL_LENGTH = 10;

export default {
  name: 'MarkerLabel',
  props: {
    x: {
      type: Number,
      required: true,
    },
    y: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    count: {
      type: [Number, String],
      default: 0,
    },
    sizeScale: {
      type: Number,
      default: 1,
    },
    showName: {
      type: Boolean,
      default: false,
    },
    showCount: {
      type: Boolean,
      default: false,
    },
    countSuffix: {
      type: String,
      default: '',
    },
    maxLabelLength: {
      type: Number,
      default: MAX_LABEL_LENGTH,
    },
  },
  computed: {
    isVisible() {
      return this.showName || this.showCount;
    },
    truncatedLabel() {
      if (!this.label || this.label.length <= this.maxLabelLength) return this.label;
      return `${this.label.slice(0, this.maxLabelLength)}\u2026`;
    },
    countDisplay() {
      const value = this.count != null ? this.count : 0;
      return this.countSuffix ? `${value}${this.countSuffix}` : value;
    },
  },
};
</script>

<style scoped>
.marker-label {
  font-family: sans-serif;
  pointer-events: none;
  user-select: none;
}
</style>
